import { render } from "./index.vue?vue&type=template&id=746daa7e&scoped=true&ts=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=746daa7e&scoped=true&lang=stylus"

import exportComponent from "/Users/rong.chen/data/zd/pc-customer-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-746daa7e"]])

export default __exports__